import { NgModule, Type } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult } from '@angular/router';
import { Observable } from 'rxjs';
import { LegacyLoaderComponent } from './modules/shared/components/legacy-loader/legacy-loader.component';
import { PageNotFoundComponent } from './modules/shared/views/pagenotfound/pagenotfound.component';

const routes: Routes = [
  {
    matcher: (s): UrlMatchResult | null => {
      if (
        s.length >= 1 &&
        (['images'].some((x) => s[0].path.toLowerCase().includes(x)) ||
          s.some((x) => x.path.includes('aspx')))
      ) {
        return { consumed: s };
      } else {
        return null;
      }
    },
    component: LegacyLoaderComponent,
  },
  {
    matcher: (u): UrlMatchResult | null => {
      if (u.length === 1) {
        const p = u[0].path;
        if (p === 'pagenotfound' || p === 'fehler') {
          return { consumed: u };
        }
      }
      return null;
    },
    component: PageNotFoundComponent,
  },
  {
    path: 'assistent',
    loadChildren: (): Type<any> | Observable<Type<any>> | Promise<any> =>
      import('src/app/modules/assistent/assistent.module').then(
        (m) => m.AssistentModule
      ),
  },
  {
    path: '',
    loadChildren: (): Type<any> | Observable<Type<any>> | Promise<any> =>
      import('src/app/modules/tarifrechner/tarifrechner.module').then(
        (m) => m.TarifrechnerModule
      ),
  },
  {
    path: '**',
    redirectTo: 'pagenotfound',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      canceledNavigationResolution: 'computed',
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollOffset: [0, 45],
      // scrollOffset fuer Tabellenansicht <table-view> auf 55 gestellt, damit auf Mobile Abstand wegen dem Header hat
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
